// extracted by mini-css-extract-plugin
export default {"GoalSelector":"style_GoalSelector__2CWt9","categories":"style_categories__ezXHa","category":"style_category__9xjj0","selected":"style_selected__if9IL"};